exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal {\n    background: rgba(0, 0, 0, 0.4);\n  }", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/components/documentlist/documentlist.component.css
// module id = ../../../../../src/app/components/documentlist/documentlist.component.css
// module chunks = main